import { Component, HostListener, OnInit } from '@angular/core';
import { Usuario } from 'src/app/core/models/usuario.model';
import { SgrResponse } from 'src/app/core/models/response.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SidenavService, SidenavStatus } from './sidenav/sidenav.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {
  sidenavStatus: SidenavStatus;
  usuarioLogado: Usuario;
  private screenWidth: number;

  constructor(
    private sidenavService: SidenavService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.usuarioLogado = this.authService.usuarioLogado();
    this.screenWidth = window.innerWidth;
    this.sidenavService.getStatus().subscribe(status => this.sidenavStatus !== status && (this.sidenavStatus = status));

    this.sincronizarEstadoPorBreakpoint();
  }

  @HostListener('window:resize')
  onResize(): void {
    const previousWidth = this.screenWidth;
    this.screenWidth = window.innerWidth;

    if (previousWidth > 1024 && this.screenWidth <= 1024) {
      this.sidenavService.definirEstadoTransitorio(true);
      return;
    }

    if (previousWidth <= 1024 && this.screenWidth > 1024) {
      this.sidenavService.restaurarPreferenciaDesktop();
    }
  }

  sidenavClosedToggle(): void {
    if (this.screenWidth > 1024) return;

    this.sidenavService.definirEstadoTransitorio(!this.sidenavStatus.closed);
  }

  private sincronizarEstadoPorBreakpoint(): void {
    if (this.screenWidth > 1024) {
      this.sidenavService.restaurarPreferenciaDesktop();
      return;
    }

    this.sidenavService.definirEstadoTransitorio(true);
  }
}
